import { AppRoute } from '@/modules/settings/types'
import {
  CompanySelectionPage,
  ErrorPage,
  NoAccessPage,
  NotFoundPage
} from './pages';
import { CORE_ROUTES } from './routes-typed'

export const coreRoutesMap : Record<string, string> = {
  noAccess: CORE_ROUTES.noAccess.path,
  notFound: CORE_ROUTES.notFound.path,
  companySelection: CORE_ROUTES.companySelection.path,
  error: CORE_ROUTES.error.path,
}

export const coreRoutes: AppRoute[] = [
  {
    path: coreRoutesMap.noAccess,
    component: NoAccessPage,
  },
  {
    path: coreRoutesMap.notFound,
    component: NotFoundPage,
  },
  {
    path: coreRoutesMap.companySelection,
    component: CompanySelectionPage,
  },
  {
    path: coreRoutesMap.error,
    component: ErrorPage,
  },
];
